"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lock = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Lock = function Lock() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.125 9.6V7.2c0-3.976-3.19-7.2-7.125-7.2S4.875 3.224 4.875 7.2v2.4C3.563 9.6 2.5 10.675 2.5 12v9.6c0 1.325 1.063 2.4 2.375 2.4h14.25c1.312 0 2.375-1.075 2.375-2.4V12c0-1.325-1.063-2.4-2.375-2.4zM7.25 7.2c0-2.65 2.127-4.8 4.75-4.8s4.75 2.15 4.75 4.8v2.4h-9.5V7.2zm5.938 12c.655 0 1.187-.537 1.187-1.2v-2.4c0-.662-.532-1.2-1.188-1.2h-2.374c-.656 0-1.188.538-1.188 1.2V18c0 .663.532 1.2 1.188 1.2h2.374z",
    clipRule: "evenodd"
  });
};

exports.Lock = Lock;